import {passwordApi} from './userServiceConfig';
import {PasswordApiPasswordResetRequest} from "@videoblocks/user-service-client/api/password-api";

const passwordReset = async (email: string, token: string, password: string): Promise<void> => {
    const requestParameters: PasswordApiPasswordResetRequest = {
        email,
        passwordResetRequest: {
            token,
            password
        }
    };
    await passwordApi.passwordReset(requestParameters);
};

const requestPasswordReset = async (email: string): Promise<void> => {
    await passwordApi.requestPasswordReset({ email });
}


export const PasswordApi = {
    passwordReset,
    requestPasswordReset
};